export default __webpack_public_path__ + "static/media/appStoreLogo.8a3146f6.svg";